import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import "./navbar.css";
import CartSidebar from "./CartSidebar";
import stores from "./storeData";

export default function Navbar() {

  const [location, setLocation] = useState(

    localStorage.getItem("storeLocation")
    || "Apple 1"
  );

  const store = stores[location];

  const changeLocation = (value) => {

    localStorage.setItem(
      "storeLocation",
      value
    );

    setLocation(value);

    window.location.reload();
  };

  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const [cartCount, setCartCount] = useState(0);

  // SIDEBAR
  const [openCart, setOpenCart] = useState(false);

  const user = localStorage.getItem("user_id");
  const name = localStorage.getItem("name");

  // LOAD CART COUNT
  const loadCartCount = () => {

    if (!user) return;

   const storeName =
  localStorage.getItem("storeLocation") || "Apple 1";
console.log("COUNT STORE:", storeName);
axios
  .get(
    `https://apple2.shopat1stop.com/api/cart-count/${user}/${storeName}`
  )

  .then((res) => {

    console.log(
      "CART COUNT API:",
      res.data
    );

    setCartCount(res.data.count);

  })

  .catch((err) => {

    console.log(err);

    setCartCount(0);

  });
  };

 useEffect(() => {

  loadCartCount();

  const refreshCart = () => {
    loadCartCount();
  };

  window.addEventListener(
    "cartUpdated",
    refreshCart
  );

  return () => {

    window.removeEventListener(
      "cartUpdated",
      refreshCart
    );

  };

}, []);

  // LOGOUT
  const logout = () => {

    localStorage.clear();

    alert("Logged out ✅");

    navigate("/login");
  };

  // SEARCH
  const handleSearch = () => {

    if (!search) return;

    navigate(`/?search=${search}`);

    setSearch("");
  };

  return (

    <>

      {/* TOP BAR */}
      <div className="top-bar">

        <div className="top-left">
          For Support : {store.email}
        </div>

        
<div className="top-right-links">

  {/* LOCATION DROPDOWN */}
  <div className="location-wrapper">

    <span className="location-icon">
      📍
    </span>

    <select
      value={location}
      onChange={(e) =>
        changeLocation(e.target.value)
      }
      className="location-select"
    >

      <option value="Apple 1">
        Select Store - Apple 1 ▼
      </option>

      <option value="Apple 2">
        Select Store - Apple 2 ▼
      </option>

    </select>

  </div>

            

          <Link to="/faqs">
            FAQs
          </Link>

          <Link to="/contact">
            Contact
          </Link>

        </div>

      </div>

      {/* MAIN NAVBAR */}
      <div className="navbar">

        {/* LEFT */}
        <div className="nav-left">

          <Link
            to="/"
            className="logo"
          >
            🍎 {store.name}
          </Link>

        </div>

        {/* CENTER */}
        <div className="nav-center">

          <input
            value={search}

            onChange={(e) =>
              setSearch(e.target.value)
            }

            onKeyDown={(e) =>
              e.key === "Enter" &&
              handleSearch()
            }

            placeholder="Search products..."

            className="search-box"
          />

          <button
            onClick={handleSearch}
            className="search-btn"
          >
            🔍
          </button>

        </div>

        {/* RIGHT */}
        <div className="nav-right">

          <Link
            to="/wishlist"
            className="wishlist-icon"
          >
            ❤️ Wishlist
          </Link>

          {/* CART */}
          <div
            className="cart-icon"
            onClick={() =>
              setOpenCart(true)
            }
          >

            🛒

            <span className="cart-count">
              {cartCount}
            </span>

          </div>

          {/* USER */}
          {user ? (

            <>

              <span className="username">
                Hello, {name}
              </span>

              <button
                onClick={logout}
                className="logout-btn"
              >
                Logout
              </button>

            </>

          ) : (

            <>

              <Link
                to="/login"
                className="login-btn"
              >
                Login
              </Link>

              <Link
                to="/register"
                className="signup-btn"
              >
                Sign Up
              </Link>

            </>
          )}

        </div>

      </div>

      {/* SIDEBAR */}
      <CartSidebar
        open={openCart}
        setOpen={setOpenCart}
      />

    </>
  );
}